'use client'

import { memo } from 'react'
import clsx from 'clsx'

import { SeoListName } from 'shared/analytics'
import { getProductLabelFormByQuantity } from 'shared/utils/language'

import { CartItem, CategoryAccTypesWithProductCount } from '../../../types'

import CartItemsListItem from './CartItemsListItem'

import styles from './CartCategoryItemsList.module.scss'

const CartCategoryItemsList = memo(
  ({
    category,
    seoButtonPlace,
    listName
  }: {
    category: CategoryAccTypesWithProductCount
    seoButtonPlace: string
    listName: SeoListName
  }) => {
    const isPromotionCategory = category.categoryName === 'Promocje'
    const productCountLabel = getProductLabelFormByQuantity(
      category.categoryItemsCount
    )

    return (
      <div key={category.categoryId}>
        {isPromotionCategory ? (
          <div
            className={clsx(styles.categoryTitle, styles.promotionCategoryTile)}
          >
            {category.categoryName}{' '}
            <span className={styles.categoryProductsCount}>
              {category.categoryItemsCount} {productCountLabel}
            </span>
          </div>
        ) : (
          <div className={styles.categoryTitle}>
            {category.categoryName}{' '}
            <span className={styles.categoryProductsCount}>
              {category.categoryItemsCount} {productCountLabel}
            </span>
          </div>
        )}
        <div className={styles.categoryProducts}>
          {category.items?.map((item: CartItem, idx: number) => (
            <CartItemsListItem
              key={`${item.id}-${idx}`}
              item={item}
              seoButtonPlace={seoButtonPlace}
              idxOnList={idx}
              listName={listName}
            />
          ))}
        </div>
      </div>
    )
  }
)

export default CartCategoryItemsList
